import { Scenarios } from '@jfs/network'

const fetchRemittanceCustomerDetails = {
  default: [
    {
      url: /fetch/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        data: {
          user: {
            name: {
              firstName: 'Aditya',
              middleName: 'Roy',
              lastName: 'Kapoor',
            },
            mobile: {
              mobileNumber: '9009911411',
              countryCode: '91',
            },
            occupationCode: 5,
            address: [
              {
                state: 'MH',
                city: 'Thane',
                pincode: 400701,
                country: 'IN',
                type: 10,
                houseNumber: '159 Sector-7',
              },
              {
                state: 'MH',
                city: 'Thane',
                pincode: 400701,
                country: 'IN',
                type: 11,
                houseNumber: '101 Sector-12',
              },
            ],
          },
          remittanceUserId: '1761344478801359769',
          userStatus: 'INACTIVE',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /fetch/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { fetchRemittanceCustomerDetails }
